/**
 * Collection of Duts
 *
 * Duts are ephemeral things. They exist for a short time before they
 * disappear. We get them via a websocket event 'dut' and they go
 * away when we get the websocket event 'blessing'. This collection
 * exists for us to keep track of them.
 *
 * There is no canonical API endpoint for Duts, so fetching this collection
 * is a futile endeavor. Instead, each device group has its own collection 
 * of duts. Like other v5 collections, we will treat this one as canonical,
 * but to get any device group's dut, you must request on the device group's
 * own collection.
 */
import v5_Collection from '@/collections/v5/collection';
import Dut from '@/models/v5/dut';

    var coll = new v5_Collection();
    coll.model = Dut;
    coll.type = Dut.type;
    export default coll;

